import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";

import { SessionService } from "./../_shared/session/session.service";
import { ProcessoService } from "./../_shared/processo/processo.service";
import { CandidatoService } from "./../_shared/candidato/candidato.service";
import { Candidato } from "./../_shared/candidato/candidato";
import { ProcessoSeletivo } from "./../_shared/processo/processo-seletivo";
import {
  anoEnemValidator,
  numeroEnemValidator,
} from "./../_shared/processo/enem-validador.directive";
import { HeaderService } from "./../_shared/http/header.service";
import { DocumentoGlobal } from "./../_shared/documento/documento-global";

@Component({
  selector: "app-ensino-medio",
  templateUrl: "./ensino-medio.component.html",
  styleUrls: ["./ensino-medio.component.css"],
})
export class EnsinoMedioComponent implements OnInit {
  public ensino;
  public conclusao;
  public declaracao: boolean;
  public textoConcluinte: string;

  public formulario: FormGroup;
  public ensino_placeholder = "Ensino médio";
  public ensino_classe: string;
  public conclusao_placeholder = "Data de conclusão";
  public conclusao_classe: string;
  public conclusao_mask = [
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  public inscricao_enem_classe: string;
  public inscricao_enem_placeholder = "Número de inscrição";
  public ano_enem_classe: string;
  public ano_enem_placeholder = "Ano da prova";

  public ProcessoSeletivo;
  public idProcesoSeletivo: number;

  private candidato: Candidato;
  public formacao;
  public periodoCursando;
  public dataConclusao: string;

  public media_candidato_classe: string;
  public media_candidato_placeholder: string = "Média";
  public solicitarMedia: boolean = false;
  public mostrarMediaMinimaMensagem: boolean = false;
  public solicitarMediaTextoExplicativo: string = "";
  public mediaMinima: number = 0;
  public mediaMinimaMensagem: string = "";
  public enemLimiteAnos: number = 3;

  constructor(
    private router: Router,
    private SessionService: SessionService,
    private ProcessoService: ProcessoService,
    private CandidatoService: CandidatoService,
    private HeaderService: HeaderService,
    private datePipe: DatePipe,
    private DocumentoGlobal: DocumentoGlobal
  ) {}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.candidato = this.CandidatoService.getCandidato();
    if (this.candidato) {
      this.ensino = this.candidato.ensino;
      this.conclusao = this.candidato.conclusao;
      this.candidato.mediaCandidato = "";
    }

    this.ProcessoSeletivo =
      this.ProcessoService.getProcessoSeletivoSelecionado();
    this.idProcesoSeletivo = this.ProcessoService.getTipoProcesso();

    if (this.HeaderService.getHeadersGnx()) {
      this.buscaEnsinoMedio();
    } else {
      this.HeaderService.getTokenGnx().subscribe(
        (data) => this.buscaEnsinoMedio(),
        (err) => err
      );
    }
  }

  buscaEnsinoMedio() {
    this.ProcessoService.getEnsinoMedio().subscribe(
      (ensinoMedio) => this.trataEnsinoMedio(ensinoMedio),
      (err) => err
    );
    this.ProcessoService.getConcluinte().subscribe(
      ({
        PrcDatLimCon,
        textoConcluinte,
        PrcQtdAnosEnem,
        PrcMedMin: mediaMinima,
        PrcMsgBlo: mediaMinimaMensagem,
        PrcSolMed: solicitarMedia,
        PrcTexExp: solicitarMediaTextoExplicativo,
      }) => {
        this.solicitarMedia = solicitarMedia;
        this.solicitarMediaTextoExplicativo = solicitarMediaTextoExplicativo;
        this.mediaMinima = mediaMinima;
        this.mediaMinimaMensagem = mediaMinimaMensagem;
        this.enemLimiteAnos = PrcQtdAnosEnem;

        this.dataConclusao = new Date(
          `${PrcDatLimCon} 11:00:00 UTC`
        ).toLocaleDateString();
        this.textoConcluinte = textoConcluinte;
      }
    );
  }

  trataEnsinoMedio(ensinoMedio) {
    if (ensinoMedio.SdtPrcCandidato) {
      this.ensino = ensinoMedio.SdtPrcCandidato.PrcCdtInsEnsMed;

      if (ensinoMedio.SdtPrcCandidato.PrcCdtDtEnsMed !== "0000-00-00") {
        this.conclusao = this.datePipe.transform(
          ensinoMedio.SdtPrcCandidato.PrcCdtDtEnsMed,
          "dd/MM/yyyy"
        );
      }
    }
  }

  removeClaseError() {
    this.conclusao_classe = "";
    this.ensino_classe = "";
    this.ano_enem_classe = "";
    this.inscricao_enem_classe = "";
  }

  somenteNumero(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      return false;
    }
  }

  trocaDeclaracao(formacao) {
    this.declaracao = formacao === "cursando" ? true : false;
  }

  validaPasso() {
    this.removeClaseError();
    this.formulario = new FormGroup({});

    if (this.solicitarMedia) {
      this.formulario.addControl(
        "media_candidato",
        new FormControl(String(this.candidato.mediaCandidato), [
          Validators.required,
          Validators.minLength(1),
          Validators.pattern("^[0-9.,]*$"),
        ])
      );

      if (this.formulario.controls.media_candidato.errors) {
        this.validForm("media_candidato", "Média");
      }
    }

    if (
      this.formacao === "concluido" ||
      (this.formacao === "cursando" && this.periodoCursando == "3")
    ) {
      this.formulario.addControl(
        "ensino",
        new FormControl(this.ensino, [
          Validators.required,
          Validators.minLength(4),
        ])
      );
      // this.formulario = new FormGroup({
      //   ensino: new FormControl(this.ensino, [
      //     Validators.required,
      //     Validators.minLength(4),
      //   ]),
      // });
    }

    if (!this.declaracao) {
      this.formulario.addControl(
        "conclusao",
        new FormControl(this.conclusao, [
          Validators.required,
          Validators.pattern(
            "^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$"
          ),
        ])
      );
    }

    if (
      (this.ProcessoService.getTipoProcesso() == 2 &&
        this.formacao === "concluido") ||
      (this.ProcessoService.getTipoProcesso() == 2 &&
        this.periodoCursando == "3")
    ) {
      this.formulario.addControl(
        "inscricao_enem",
        new FormControl(this.candidato.PrcCdtEnemNum, [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(12),
          numeroEnemValidator(parseInt(this.candidato.PrcCdtEnemNum, 10)),
        ])
      );
      this.formulario.addControl(
        "ano_enem",
        new FormControl(this.candidato.PrcCdtEnemAno, [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          anoEnemValidator(
            parseInt(this.candidato.PrcCdtEnemAno, 10),
            this.ProcessoSeletivo.PrcLetAno,
            this.enemLimiteAnos
          ),
        ])
      );
    }

    if (this.formulario.status === "INVALID") {
      if (
        this.formacao === "concluido" ||
        (this.formacao === "cursando" && this.periodoCursando == "3")
      ) {
        this.validForm("ensino", "Ensino médio");
      }

      if (!this.declaracao) {
        this.validForm("conclusao", "Data de conclusão");
      }
      if (
        (this.ProcessoService.getTipoProcesso() == 2 &&
          this.formacao == "concluido") ||
        (this.ProcessoService.getTipoProcesso() == 2 &&
          this.periodoCursando == "3")
      ) {
        if (this.formulario.controls.ano_enem.errors) {
          this.candidato.PrcCdtEnemAno = "";
        }
        if (this.formulario.controls.inscricao_enem.errors) {
          this.candidato.PrcCdtEnemNum = "";
        }
        this.validForm("ano_enem", "Ano da prova");
        this.validForm("inscricao_enem", "Número de inscrição do Enem");
      }
    } else {
      const mediaCandidatoString = String(this.candidato.mediaCandidato);

      if (mediaCandidatoString.length > 0) {
        if (mediaCandidatoString.indexOf(",") >= 0) {
          if (
            mediaCandidatoString.length - 1 >
            mediaCandidatoString.indexOf(",")
          ) {
            this.candidato.mediaCandidato = Number(
              String(this.candidato.mediaCandidato).replace(",", ".")
            );
          } else {
            this.candidato.mediaCandidato = Number(
              String(this.candidato.mediaCandidato).replace(",", "")
            );
          }
        }
      }

      if (this.isMostrarMediaMinimaMensagem()) {
        Swal({
          title: "Média/Pontuação inválida",
          width: 500,
          text: this.mediaMinimaMensagem,
          type: "error",
          showCancelButton: false,
          confirmButtonText: "OK",
        });
        return;
      }

      const dataValidada = this.validaDataConclusao();
      if (dataValidada === true) {
        Swal({
          title: "Data inválida",
          width: 500,
          text: "A data de conclusão informada é maior que a data atual",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "ok",
        });
      } else {
        let string_data = null;
        if (this.conclusao) {
          this.conclusao =
            this.formacao === "cursando" ? "0000-00-00" : this.conclusao;
          string_data =
            this.conclusao.substr(6, 4) +
            "-" +
            this.conclusao.substr(3, 2) +
            "-" +
            this.conclusao.substr(0, 2);
        }
        //se declaracao === false limpa periodoCursando
        if (this.declaracao === false) {
          this.periodoCursando = null;
        }
        if (this.periodoCursando == "2" || this.periodoCursando == "1") {
          this.ensino = "";
          this.conclusao = "";
          this.candidato.PrcCdtEnemNum = "";
          this.candidato.PrcCdtEnemAno = 0;
        }
        this.guardaMensagemConcluinte();
        if (!this.periodoCursando) {
          this.periodoCursando = 0;
        }
        this.CandidatoService.salvaCandidato(
          this.ensino,
          string_data,
          this.declaracao,
          this.periodoCursando
        ).subscribe(
          (data) => this.trataPasso(data),
          (err) => {
            throw new Error();
          }
        );
      }
    }
  }

  guardaMensagemConcluinte() {
    if (
      this.declaracao &&
      (this.periodoCursando == "2" || this.periodoCursando == "1")
    ) {
      sessionStorage.setItem("textoConcluinte", this.textoConcluinte);
    }
  }

  validaDataConclusao() {
    if (this.conclusao) {
      const dataAtual = new Date();
      const dataConclusao = new Date(
        this.conclusao.substr(6, 4) +
          "/" +
          this.conclusao.substr(3, 2) +
          "/" +
          this.conclusao.substr(0, 2)
      );
      return dataConclusao > dataAtual;
    }
  }

  trataPasso(data) {
    if (data.Messages.length > 0) {
      Swal(data.Messages[0].Description);
      throw new Error();
    }

    if (!data.SdtPrcCandidato.PrcCdtCod) {
      throw new Error();
    }

    this.candidato.PrcCdtCod = data.SdtPrcCandidato.PrcCdtCod;
    this.candidato.ensino = this.ensino;
    this.candidato.conclusao = this.conclusao;
    this.candidato.concluinte = this.declaracao;
    this.candidato.PeriodoEnsino = this.periodoCursando;
    if (
      this.ProcessoService.getTipoProcesso() == 2 &&
      this.formacao === "cursando" &&
      this.periodoCursando != "3"
    ) {
      this.candidato.PrcCdtEnemAno = 0;
      this.candidato.PrcCdtEnemNum = "";
    }
    this.CandidatoService.setCandidato(this.candidato);

    const dados_candidato = JSON.parse(
      this.SessionService.getValor("dadosCandidato")
    );
    const curso_selecionado = JSON.parse(
      this.SessionService.getValor("cursoSelecionado")
    );

    // verifica se tem inscricao em outro oferecimento para confirmar a exclusao
    this.DocumentoGlobal.inscricoes = data.SdtPrcCandidato.PrcIncricoes;

    const inscricoes = data.SdtPrcCandidato.PrcIncricoes;
    let pergunta = false;

    if (inscricoes.length >= 1) {
      inscricoes.forEach((inscricao) => {
        if (
          inscricao.PrcOfeSeq !== curso_selecionado.PrcOfeSeq &&
          !inscricao.inscricaoDeferida
        ) {
          //inscricao deferida controla se chama a postagem de documento ou não
          pergunta = true;
        }
      });
    }

    if (pergunta) {
      Swal({
        title: "Já existe um processo de inscrição em aberto",
        width: 500,
        text: 'Ao clicar em "Continuar" o processo anterior será imediatamente cancelado. Deseja continuar?',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value === true) {
          this.salvaInscricao(data);
        }
      });
    } else {
      this.salvaInscricao(data);
    }
  }

  salvaInscricao(data) {

    const curso_selecionado = JSON.parse( this.SessionService.getValor("cursoSelecionado") );

    this.CandidatoService.deleteCandidatoCancelado(this.candidato, curso_selecionado).subscribe((response) => {

        this.CandidatoService.salvaDadosCandidato(this.candidato).subscribe(
        (result) => {
          this.SessionService.setValor("dadosCandidato", JSON.stringify(result));
          this.CandidatoService.getTodosDocumentos().subscribe(
            (documentosCandidato) => this.proximo(documentosCandidato),
            (err) => err
          );
        },
        (err) => {
          if (err.error.message === "Já existe o registro") {
            //   Swal({
            //     title: err.error.message,
            //     width: 500,
            //     text:
            //       "Você já possui inscrição no Seletivo Univali, para este mesmo curso. Clique abaixo para saber mais.",
            //     type: "warning",
            //     showCancelButton: false,
            //     confirmButtonText: "ok",
            //   }).then(() => {

            if (
              this.ProcessoService.checkAbrirPaginaDocumentos() &&
              !this.checkPeriodoCursandoPrimeiroOuSegundo()
            ) {
              this.CandidatoService.getTodosDocumentos().subscribe(
                (documentosCandidato) => {
                  this.CandidatoService.setDocumentosCandidato(
                    documentosCandidato
                  );
                  this.router.navigate(["/pergunta-documentos"]);
                },
                (err) => {
                  return err;
                }
              );
            } else if (
              this.SessionService.getValor("matricula_redirecionar") === "true"
            ) {
              this.router.navigate(["/mensagem-final-matricula-online"]);
            } else {
              this.router.navigate(["/mensagem-final"]);
            }
          }
          //   );
          // }
          else {
            Swal(err.error.message);
          }
        }
      );

    }, (err) => {
      Swal('Erro ao prosseguir com a inscrição. Tente novamente mais tarde.');
    });
  }

  checkPeriodoCursandoPrimeiroOuSegundo(): boolean {
    const periodoCursandoPrimeiroOuSegundo =
      (this.formacao === "cursando" && this.periodoCursando === "1") ||
      (this.formacao === "cursando" && this.periodoCursando === "2");

    return periodoCursandoPrimeiroOuSegundo;
  }

  proximo(documentosCandidato) {
    this.CandidatoService.setDocumentosCandidato(documentosCandidato);

    // let perguntaDocumentos = false;

    // if (documentosCandidato.length >= 1) {
    //   documentosCandidato.forEach((documento) => {
    //     if (documento.temDocPostado) {
    //       perguntaDocumentos = true;
    //     }
    //   });
    // }
    if (
      this.ProcessoService.checkAbrirPaginaDocumentos() &&
      !this.checkPeriodoCursandoPrimeiroOuSegundo()
    ) {
      this.router.navigate(["/pergunta-documentos"]);
    } else if (
      this.ProcessoService.getMatriculaRedirecionamento() &&
      !this.checkPeriodoCursandoPrimeiroOuSegundo()
    ) {
      this.router.navigate(["/mensagem-final-matricula-online"]);
    } else {
      this.router.navigate(["/mensagem-final"]);
    }

    // if (perguntaDocumentos) {
    //     this.router.navigate(['/pergunta-documentos']);
    // } else {
    //     this.router.navigate(['/documentos']);
    // }

    // this.SessionService.setValor('final', 'true');
    // this.router.navigate(['/mensagem-final']);
  }

  validForm(campo, nome) {
    if (!this.formulario.controls[campo].valid) {
      this[campo] = "";
      if (this.formulario.controls[campo].errors["required"]) {
        this[campo + "_classe"] = "classWarning";
        this[campo + "_placeholder"] = nome + " é obrigatório";
      } else {
        this[campo + "_classe"] = "classErro";
        this[campo + "_placeholder"] = nome + " está inválido";

        if (this.formulario.controls[campo].errors["error"]) {
          this[campo + "_placeholder"] =
            this.formulario.controls[campo].errors["error"];
        }
      }
    }
  }

  isMostrarMediaMinimaMensagem() {
    if (Number(this.candidato.mediaCandidato) < Number(this.mediaMinima)) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/ensino-medio/ensino-medio.component.ts